import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalizeFirstLetter'
})
export class CapitalizeFirstLetterPipe implements PipeTransform {

  transform(value: string | null | undefined): string {
    if (!value?.length) return '';
    
    // If text is already all uppercase, leave it as is
    if (value === value.toUpperCase()) {
      return value;
    }

    // Capitalize: convert to lowercase first, then capitalize first letter of each word
    return value
      .toLowerCase()
      .split(' ')
      .map(word => {
        if (word.length === 0) return word;
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  }

}
